define('facebook/fb',['require','exports','module','bam.url/url','jquery.bindable/jquery.bindable'],function( require, exports, module ) {

    var urlModule = require('bam.url/url');
    var bindable = require("jquery.bindable/jquery.bindable");
    
    var module = {},
        out = {},
        that,
        version = "v2.0",

            // events
            EVENT_NOT_LOGGEDIN = "notLoggedIn",
            EVENT_IS_LOGGEDIN = "isLoggedIn",

            USER_INFO = version+ '/me',
            USER_FRIENDS = version+ '/me/friends',
            USER_NEWS_FEED = version+ '/me/home',
            USER_WALL_FEED = version+ '/me/feed',
            USER_LIKES = version+ '/me/likes',
            USER_MOVIES = version+ '/me/movies',
            USER_BOOKS = version+ '/me/books',
            USER_NOTES = version+ '/me/notes',
            USER_PHOTOS = version+ '/me/photos',
            USER_ALBUMS = version+ '/me/albums',
            USER_VIDEOS = version+ '/me/videos',
            USER_EVENTS = version+ '/me/events',
            USER_GROUPS = version+ '/me/groups',
            USER_CHECKINS = version+ '/me/checkins',
            dclang        = (typeof dc_lang !== 'undefined') ? dc_lang : "",    

            fbscript = (dclang === 'es') ? "//connect.facebook.net/es_ES/sdk.js" : "//connect.facebook.net/en_US/sdk .js",

            doNothing = function () {},
            loadingFB = false,
            site    = window.location.hostname,
            evn     = (site.match(/^.*?-?(\w*)\./) || ['','dev'])[1],
            trackLike = false;
            
            exports.init = function (cfg) {
                var that = this,
                    dfd = $.Deferred(),
                    site = urlModule.Location(window.location).getDomain() + '.com';

                                        
                if (!window.FB && !loadingFB) {
                   
                    cfg = $.extend({
                            appId: (window.location.hostname === 'qa.mlb.com') ? $("meta[property='fb:app_id']").attr("content") : $("meta[property='fb:app_id']").attr("content") || "7848098180",                            
                            // test app on qa and beta, only MLB appId on prod
                            cookie     : true,  // enable cookies to allow the server to access
                            xfbml      : true,  // parse social plugins on this page
                            version    : version // use version 2.0
                        }, cfg);
                        
                    
                   if ($("#fb-root").length === 0) {
                        $('body').prepend('<div id="fb-root"></div>');                        
                   }

                
                  
                   window.fbAsyncInit = function() {
                       loadingFB = true;
                       FB.init(cfg);
                       $(window).trigger("bam.social.fbready");
                       that.trigger("FBApiInit");
                       dfd.resolve();
                 };
                 
                 (function(d, s, id){
                   var js, fjs = d.getElementsByTagName(s)[0];
                   if (d.getElementById(id)) {return;}
                   js = d.createElement(s); js.id = id;
                   js.src = "//connect.facebook.net/en_US/sdk.js";
                   fjs.parentNode.insertBefore(js, fjs);
                  }(document, 'script', 'facebook-jssdk'));
                  


                } else {
                   
                  
                   dfd.resolve();
                   $(window).trigger("bam.social.fbready");
                   
                }
                return dfd.promise();

            };


            exports.ready = $.Deferred();

            exports.render = function () {
                if (window.FB) {
                FB.XFBML.parse();
                }
            };

            exports.api = {

                userInfo: function (callback) {
                    this.execute(USER_INFO, callback);
                },
                userFriends: function (callback) {
                    this.execute(USER_FRIENDS, callback);
                },
                userNewsFeed: function (callback) {
                    this.execute(USER_NEWS_FEED, callback);
                },
                userWallFeed: function (callback) {
                    this.execute(USER_WALL_FEED, callback);
                },
                userLikes: function (callback) {
                    this.execute(USER_LIKES, callback);
                },
                userMovies: function (callback) {
                    this.execute(USER_MOVIES, callback);
                },
                userBooks: function (callback) {
                    this.execute(USER_BOOKS, callback);
                },
                userNotes: function (callback) {
                    this.execute(USER_NOTES, callback);
                },
                userPhotos: function (callback) {
                    this.execute(USER_PHOTOS, callback);
                },
                userAlbums: function (callback) {
                    this.execute(USER_ALBUMS, callback);
                },
                userVideos: function (callback) {
                    this.execute(USER_VIDEOS, callback);
                },
                userEvents: function (callback) {
                    this.execute(USER_EVENTS, callback);
                },
                userGroups: function (callback) {
                    this.execute(USER_GROUPS, callback);
                },
                userCheckins: function (callback) {
                    this.execute(USER_CHECKINS, callback);
                },
                execute: function (method, callback) {
                    FB.api(method, (typeof callback == "function" ? callback : doNothing));
                }

            }

            exports.auth = {
                login: function (perms) {
                    FB.login(function (response) {
                        if (response.session && response.perms) {
                            //user successfully login
                            that.trigger(EVENT_IS_LOGGEDIN);
                        } else {
                            //user cancelled login or did not grant authorization
                            that.trigger(EVENT_NOT_LOGGEDIN);

                        }
                    }, {
                        scope: perms
                    });
                },

                logout: function () {
                    FB.logout(function (response) {
                        that.trigger(EVENT_IS_LOGOUT);
                    });
                },

                update: function (response) {

                    if (!response.session || !response.perms) {
                        that.trigger(EVENT_NOT_LOGGEDIN);
                    } else {
                        that.trigger(EVENT_IS_LOGGEDIN);
                    }

                }
            };

            exports.event = {
                subscribe: function (event, cb) {
                    FB.Event.subscribe(event, cb);
                    return this;
                },
                
                unsubscribe: function (event, cb) {
                    FB.Event.unsubscribe(event, cb);
                    return this;
                }

            };

            exports.fql = {};

            exports.iframes = {

                like: function (cfg) {
                    var isFBML = cfg.svc_cfg.isFBML,
                        ref = (cfg.svc_cfg.ref) ? "ref="+cfg.svc_cfg.ref : "",
                        url = (cfg.svc_cfg.url) ? cfg.svc_cfg.url : cfg.url,
                        frametag = (cfg.parent.cfg.sequenceloading || cfg.parent.cfg.manuallyloading) ? "data-url" : "src";
                    
                   $(cfg.target).empty().html((isFBML) ? '<div class="fb-like" data-href="' + cfg.parent.cfg.url + '" data-send="false" data-layout="' + cfg.svc_cfg.layout + '" data-width="' + cfg.width + '" data-height="' + cfg.height + '" data-show-faces="' + cfg.svc_cfg.showface + '" data-action="' + cfg.svc_cfg.action + '"'+ref+'></div>' : '<iframe class="fb-like" '+frametag+'="//www.facebook.com/plugins/like.php?href=' + encodeURIComponent(cfg.parent.cfg.url) + '&amp;'+ref+'&amp;layout=' + cfg.svc_cfg.layout + '&amp;width=' + cfg.width + '&amp;action=' + cfg.svc_cfg.action + '&amp;height=' + cfg.height + '" scrolling="no" frameborder="0"  allowTransparency="true"></iframe>')
                    
                                    
                    if (!isFBML) {
                        $(cfg.target).css({
                            'border': 'none',
                            'overflow': 'hidden',
                            'height': cfg.height + 'px',
                            'width': cfg.width + 'px'
                        });
                    } else {
                       if (cfg.svc_cfg.omniture) {                         
                          exports.unbind("FBLike");
                          exports.bind("FBLike", function() {
                             
                             if (cfg.omniture && bam && bam.tracking && bam.tracking.track) {
                               bam.tracking.track(cfg.svc_cfg.omniture);
                             } else if (cfg.svc_cfg.omniture && typeof fireTracking === 'function') {
                               if (cfg.svc_cfg.omniture.pagename && cfg.svc_cfg.omniture.sectionid) {
                                    fireTracking(cfg.svc_cfg.omniture.pagename, cfg.svc_cfg.omniture.sectionid);
                               }
                             }
                             
                             
                          })                                                    
                       }
                       
                       if (!cfg.parent.cfg.manuallyloading) {
                         if (window.FB) {
                             FB.XFBML.parse();
                         } else {
                            $(window).bind("bam.social.fbready", function() {
                             FB.XFBML.parse();
                            });
                         }                 
                       }
                    }
                    

                },

                comments: function (cfg) {}
            };

        

    bindable(exports);
    

});

